<div class="status-filter">
  <label mat-icon-button *ngFor="let fb of buttons" class=""
    [ngClass]="{'selected': fb.value === value }">
    <input type="radio" name="filter" value="{{ fb.value }}" [(ngModel)]="value" (ngModelChange)="onChanged()" />
    <div class="filter-content">
      <div class="filter-label">{{ fb.text | translate }}</div>
    </div>
  </label>
</div>
